// ─────────────────────────────────────────────────────────────────────────────
// COUNTRIES AND NATIONALITIES
//
// "Can nationality or addresses have drop downs that will populate when you
// type."
//
// A free-text country field is how "UK", "United Kingdom", "Great Britain" and
// "England" end up in the same register meaning the same thing, and why nobody
// can then answer which beneficial owners are resident where. A FATCA or CRS
// return wants the country as a value, not a spelling.
//
// This is a datalist rather than a hard select: the list suggests, and somebody
// can still type something that is not on it. A country list that refuses an
// answer is worse than one that suggests, because the territories people
// actually hold passports for outrun any list — and a register that cannot
// record the truth gets a note beside it instead.
//
// The jurisdictions Affinity operates in come first, because they are most of
// what gets typed.
// ─────────────────────────────────────────────────────────────────────────────

export const HOME_JURISDICTIONS = [
  "Isle of Man", "Malta", "Cayman Islands", "Cyprus",
  "United Kingdom", "United States",
];

export const COUNTRIES = [
  ...HOME_JURISDICTIONS,
  "Ireland", "Jersey", "Guernsey", "Gibraltar", "Switzerland", "Luxembourg",
  "Liechtenstein", "Monaco", "Netherlands", "Belgium", "France", "Germany",
  "Spain", "Portugal", "Italy", "Greece", "Austria", "Denmark", "Sweden",
  "Norway", "Finland", "Poland", "Czech Republic", "Hungary", "Romania",
  "Bulgaria", "Croatia", "Slovenia", "Slovakia", "Estonia", "Latvia",
  "Lithuania", "Iceland",
  "British Virgin Islands", "Bermuda", "Bahamas", "Barbados", "Anguilla",
  "Turks and Caicos Islands", "Curacao", "Aruba", "Panama", "Belize",
  "Canada", "Mexico", "Brazil", "Argentina", "Chile", "Colombia", "Uruguay",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman",
  "Israel", "Turkey", "Lebanon", "Jordan", "Egypt",
  "South Africa", "Mauritius", "Seychelles", "Nigeria", "Kenya", "Ghana",
  "Botswana", "Namibia", "Morocco", "Tunisia",
  "Australia", "New Zealand", "Singapore", "Hong Kong", "China", "Japan",
  "South Korea", "Taiwan", "India", "Malaysia", "Thailand", "Indonesia",
  "Philippines", "Vietnam", "Pakistan", "Bangladesh", "Sri Lanka",
  "Russia", "Ukraine", "Kazakhstan", "Georgia", "Armenia",
];

// Nationalities as people write them, which is not the country name. Somebody
// is British rather than "of the United Kingdom", and a register that says the
// latter reads as though a machine filled it in.
export const NATIONALITIES = [
  "Manx", "British", "Irish", "Maltese", "Caymanian", "Cypriot",
  "American", "Canadian", "Australian", "New Zealander",
  "French", "German", "Spanish", "Portuguese", "Italian", "Greek", "Dutch",
  "Belgian", "Swiss", "Austrian", "Danish", "Swedish", "Norwegian", "Finnish",
  "Polish", "Czech", "Hungarian", "Romanian", "Bulgarian", "Croatian",
  "Luxembourgish", "Monegasque", "Liechtensteiner", "Icelandic",
  "South African", "Nigerian", "Kenyan", "Ghanaian", "Mauritian",
  "Egyptian", "Moroccan", "Israeli", "Turkish", "Lebanese", "Jordanian",
  "Emirati", "Saudi", "Qatari", "Kuwaiti", "Bahraini", "Omani",
  "Chinese", "Japanese", "South Korean", "Taiwanese", "Singaporean",
  "Indian", "Pakistani", "Bangladeshi", "Sri Lankan", "Malaysian", "Thai",
  "Indonesian", "Filipino", "Vietnamese",
  "Brazilian", "Argentine", "Chilean", "Colombian", "Mexican", "Uruguayan",
  "Panamanian", "Bahamian", "Barbadian", "Bermudian",
  "Russian", "Ukrainian", "Kazakh", "Georgian", "Armenian",
];
